import { mapState } from 'vuex';
import { vuetifyColors } from '@/utils/themes';
export default {
  name: 'NiotaClassicCommonN1CardBody',
  // mixins: [listMixin],
  ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions']),
  props: {
    items: {
      type: Array,
      required: false,
      default: null
    },
    property: {
      type: String,
      required: false,
      default: ''
    },
    packets: {
      type: Boolean,
      required: false
    },
    infoProperty1: {
      type: String,
      required: false,
      default: ''
    },
    isLoading: {
      type: Boolean,
      required: false,
      default: false
    },
    maxHeight: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function () {
    return {};
  },
  computed: {},
  watch: {},
  created() {
    // this.items = cloneDeep(this.items);
  },
  methods: {
    timeColorFn() {
      return vuetifyColors['success'];
    },
    timestampToTimeOnly(timestamp) {
      return new Date(timestamp).toLocaleTimeString('en-GB');
    },
    viewDevice(item) {
      this.$router.push({
        path: `/niota-classic/devices/${this.infoProperty1 === 'source_time' ? item.device_id : item.id}/details`
      });
    }
  }
};